import { render, staticRenderFns } from "./TheMenuLeftSection.vue?vue&type=template&id=f013de40&scoped=true&"
import script from "./TheMenuLeftSection.vue?vue&type=script&lang=js&"
export * from "./TheMenuLeftSection.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuLeftSection.vue?vue&type=style&index=0&id=f013de40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f013de40",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Tooltip: require('/app/components/partials/Tooltip.vue').default})
